/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type legendPlusOffersQueryVariables = {||};
export type legendPlusOffersQueryResponse = {|
  +payment: ?{|
    +corpo: ?{|
      +plans: ?$ReadOnlyArray<?any>
    |}
  |}
|};
export type legendPlusOffersQuery = {|
  variables: legendPlusOffersQueryVariables,
  response: legendPlusOffersQueryResponse,
|};
*/


/*
query legendPlusOffersQuery {
  payment {
    corpo {
      plans: getPublicPlans
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PaymentQuery",
    "kind": "LinkedField",
    "name": "payment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PaymentCorpoQuery",
        "kind": "LinkedField",
        "name": "corpo",
        "plural": false,
        "selections": [
          {
            "alias": "plans",
            "args": null,
            "kind": "ScalarField",
            "name": "getPublicPlans",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "legendPlusOffersQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "legendPlusOffersQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "d90fb99bd3f02f1e7a502f931ec49e7e",
    "id": null,
    "metadata": {},
    "name": "legendPlusOffersQuery",
    "operationKind": "query",
    "text": "query legendPlusOffersQuery {\n  payment {\n    corpo {\n      plans: getPublicPlans\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '72840d8e2073ddbe6e29fb3ce40b7015';

module.exports = node;
